import React, { useState } from "react";
import "./threedotPopup.css";
import DeleteReply from "./ThreeDot_Edit _Delete/DeleteReply";

const ThreedotPopup = ({
  setClickEditReply,
  setClickThreeDot,
  setDelet,
  delet,
  user
}) => {
  return (
    <>
      {!delet && (
        <div className=" p-3 AssessPopupBox ">
          {user && (
            <button
              className="popup_btn"
              onClick={(e) => {
                setClickEditReply(true);
                setClickThreeDot(false);
              }}
            >
              Edit
            </button>
          )}
          <button
            className="popup_btn"
            onClick={(e) => {
              setDelet(true);
            }}
          >
            Delete
          </button>
        </div>
      )}
    </>
  );
};

export default ThreedotPopup;
